import { create } from 'zustand';

import { TrapTableType } from 'components/TrapsTables/trapTables';

interface ManageTrapModalState {
  slug: string;
  isOpen: boolean;
  trapType?: TrapTableType;
  onManageTrapModalClose: () => void;
  onManageTrapModalOpen: (slug: string, trapType?: TrapTableType) => void;
}

export const useManageTrapModalStore = create<ManageTrapModalState>(set => ({
  isOpen: false,
  slug: '',
  trapId: undefined,
  trapType: undefined,
  onManageTrapModalClose: () => set({ isOpen: false, slug: '', trapType: undefined }),
  onManageTrapModalOpen: (slug: string, trapType?: TrapTableType) => set({ isOpen: true, slug, trapType }),
}));
